module.exports = __webpack_public_path__ + "static/media/p2_13.84e6862d.png";